import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-artikelkz7-list-view',
  imports: [],
  templateUrl: './artikelkz7.list-view.html',
  styleUrls: ['./artikelkz7.list-view.css'],
})
export class Artikelkz7ListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
